// extracted by mini-css-extract-plugin
module.exports = {"CategoryGridEdito":"styles_CategoryGridEdito__oce2q","title":"styles_title__vwuwY","content":"styles_content___EksT","slider":"styles_slider__fSpuX","card":"styles_card__hkb8H"};